module.exports = __webpack_public_path__ + "assets/img/37-m.6c8a0db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/37-m.jpg
// module id = SgGY
// module chunks = 0